/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BulkTranslationTaskView,
    BulkTranslationTaskViewFromJSON,
    BulkTranslationTaskViewToJSON,
    CommunicationLanguage,
    CommunicationLanguageFromJSON,
    CommunicationLanguageToJSON,
    CommunicationStatus,
    CommunicationStatusFromJSON,
    CommunicationStatusToJSON,
    CreateClientCommunication,
    CreateClientCommunicationFromJSON,
    CreateClientCommunicationToJSON,
    ObjectTypeEnum,
    ObjectTypeEnumFromJSON,
    ObjectTypeEnumToJSON,
    PostCommunicationItem,
    PostCommunicationItemFromJSON,
    PostCommunicationItemToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PutClientCommunication,
    PutClientCommunicationFromJSON,
    PutClientCommunicationToJSON,
    PutCommunicationItem,
    PutCommunicationItemFromJSON,
    PutCommunicationItemToJSON,
    ViewCommunication,
    ViewCommunicationFromJSON,
    ViewCommunicationToJSON,
    ViewCommunicationItem,
    ViewCommunicationItemFromJSON,
    ViewCommunicationItemToJSON,
} from '../models';

export interface CommunicationAddCommunicationItemRequest {
    id: string;
    postCommunicationItem?: PostCommunicationItem;
}

export interface CommunicationCreateClientCommunicationRequest {
    createClientCommunication?: CreateClientCommunication;
}

export interface CommunicationDeleteClientCommunicationForObjectIdRequest {
    id: string;
}

export interface CommunicationDeleteCommunicationItemRequest {
    communicationId: string;
    communicationItemId: string;
}

export interface CommunicationGetBulkTranslationTaskRequest {
    taskId: string;
}

export interface CommunicationGetBulkTranslationTaskByCommunicationRequest {
    id: string;
}

export interface CommunicationGetCommunicationsForObjectRequest {
    objectId?: string;
    type?: ObjectTypeEnum;
}

export interface CommunicationGetFirmCommunicationsRequest {
    lowerBound?: CommunicationStatus;
    upperBound?: CommunicationStatus;
}

export interface CommunicationPutCommunicationItemRequest {
    id: string;
    putCommunicationItem?: PutCommunicationItem;
}

export interface CommunicationStartBulkTranslationRequest {
    id: string;
    toLang?: CommunicationLanguage;
}

export interface CommunicationTranslateCommunicationItemRequest {
    commId: string;
    id: string;
    toLang?: CommunicationLanguage;
}

export interface CommunicationUpdateCommunicationRequest {
    id: string;
    putClientCommunication?: PutClientCommunication;
}

/**
 * 
 */
export class CommunicationApi extends runtime.BaseAPI {

    /**
     */
    async communicationAddCommunicationItemRaw(requestParameters: CommunicationAddCommunicationItemRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ViewCommunicationItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationAddCommunicationItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{id}/communication-item`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostCommunicationItemToJSON(requestParameters.postCommunicationItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewCommunicationItemFromJSON(jsonValue));
    }

    /**
     */
    async communicationAddCommunicationItem(requestParameters: CommunicationAddCommunicationItemRequest, initOverrides?: RequestInit): Promise<ViewCommunicationItem> {
        const response = await this.communicationAddCommunicationItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationCreateClientCommunicationRaw(requestParameters: CommunicationCreateClientCommunicationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ViewCommunication>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientCommunicationToJSON(requestParameters.createClientCommunication),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewCommunicationFromJSON(jsonValue));
    }

    /**
     */
    async communicationCreateClientCommunication(requestParameters: CommunicationCreateClientCommunicationRequest, initOverrides?: RequestInit): Promise<ViewCommunication> {
        const response = await this.communicationCreateClientCommunicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationDeleteClientCommunicationForObjectIdRaw(requestParameters: CommunicationDeleteClientCommunicationForObjectIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationDeleteClientCommunicationForObjectId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/objectid/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communicationDeleteClientCommunicationForObjectId(requestParameters: CommunicationDeleteClientCommunicationForObjectIdRequest, initOverrides?: RequestInit): Promise<void> {
        await this.communicationDeleteClientCommunicationForObjectIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communicationDeleteCommunicationItemRaw(requestParameters: CommunicationDeleteCommunicationItemRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.communicationId === null || requestParameters.communicationId === undefined) {
            throw new runtime.RequiredError('communicationId','Required parameter requestParameters.communicationId was null or undefined when calling communicationDeleteCommunicationItem.');
        }

        if (requestParameters.communicationItemId === null || requestParameters.communicationItemId === undefined) {
            throw new runtime.RequiredError('communicationItemId','Required parameter requestParameters.communicationItemId was null or undefined when calling communicationDeleteCommunicationItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{communicationId}/communication-item/{communicationItemId}`.replace(`{${"communicationId"}}`, encodeURIComponent(String(requestParameters.communicationId))).replace(`{${"communicationItemId"}}`, encodeURIComponent(String(requestParameters.communicationItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communicationDeleteCommunicationItem(requestParameters: CommunicationDeleteCommunicationItemRequest, initOverrides?: RequestInit): Promise<void> {
        await this.communicationDeleteCommunicationItemRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communicationGetBulkTranslationTaskRaw(requestParameters: CommunicationGetBulkTranslationTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BulkTranslationTaskView>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling communicationGetBulkTranslationTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/translate-task/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkTranslationTaskViewFromJSON(jsonValue));
    }

    /**
     */
    async communicationGetBulkTranslationTask(requestParameters: CommunicationGetBulkTranslationTaskRequest, initOverrides?: RequestInit): Promise<BulkTranslationTaskView> {
        const response = await this.communicationGetBulkTranslationTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationGetBulkTranslationTaskByCommunicationRaw(requestParameters: CommunicationGetBulkTranslationTaskByCommunicationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BulkTranslationTaskView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationGetBulkTranslationTaskByCommunication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{id}/translate-task`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkTranslationTaskViewFromJSON(jsonValue));
    }

    /**
     */
    async communicationGetBulkTranslationTaskByCommunication(requestParameters: CommunicationGetBulkTranslationTaskByCommunicationRequest, initOverrides?: RequestInit): Promise<BulkTranslationTaskView> {
        const response = await this.communicationGetBulkTranslationTaskByCommunicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationGetCommunicationsForObjectRaw(requestParameters: CommunicationGetCommunicationsForObjectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ViewCommunication>>> {
        const queryParameters: any = {};

        if (requestParameters.objectId !== undefined) {
            queryParameters['objectId'] = requestParameters.objectId;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViewCommunicationFromJSON));
    }

    /**
     */
    async communicationGetCommunicationsForObject(requestParameters: CommunicationGetCommunicationsForObjectRequest, initOverrides?: RequestInit): Promise<Array<ViewCommunication>> {
        const response = await this.communicationGetCommunicationsForObjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationGetFirmCommunicationsRaw(requestParameters: CommunicationGetFirmCommunicationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ViewCommunication>>> {
        const queryParameters: any = {};

        if (requestParameters.lowerBound !== undefined) {
            queryParameters['lowerBound'] = requestParameters.lowerBound;
        }

        if (requestParameters.upperBound !== undefined) {
            queryParameters['upperBound'] = requestParameters.upperBound;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/firm-communications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViewCommunicationFromJSON));
    }

    /**
     */
    async communicationGetFirmCommunications(requestParameters: CommunicationGetFirmCommunicationsRequest, initOverrides?: RequestInit): Promise<Array<ViewCommunication>> {
        const response = await this.communicationGetFirmCommunicationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationPutCommunicationItemRaw(requestParameters: CommunicationPutCommunicationItemRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ViewCommunicationItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationPutCommunicationItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{id}/communication-item`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutCommunicationItemToJSON(requestParameters.putCommunicationItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewCommunicationItemFromJSON(jsonValue));
    }

    /**
     */
    async communicationPutCommunicationItem(requestParameters: CommunicationPutCommunicationItemRequest, initOverrides?: RequestInit): Promise<ViewCommunicationItem> {
        const response = await this.communicationPutCommunicationItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationStartBulkTranslationRaw(requestParameters: CommunicationStartBulkTranslationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BulkTranslationTaskView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationStartBulkTranslation.');
        }

        const queryParameters: any = {};

        if (requestParameters.toLang !== undefined) {
            queryParameters['toLang'] = requestParameters.toLang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{id}/translate-bulk`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkTranslationTaskViewFromJSON(jsonValue));
    }

    /**
     */
    async communicationStartBulkTranslation(requestParameters: CommunicationStartBulkTranslationRequest, initOverrides?: RequestInit): Promise<BulkTranslationTaskView> {
        const response = await this.communicationStartBulkTranslationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationTranslateCommunicationItemRaw(requestParameters: CommunicationTranslateCommunicationItemRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ViewCommunicationItem>> {
        if (requestParameters.commId === null || requestParameters.commId === undefined) {
            throw new runtime.RequiredError('commId','Required parameter requestParameters.commId was null or undefined when calling communicationTranslateCommunicationItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationTranslateCommunicationItem.');
        }

        const queryParameters: any = {};

        if (requestParameters.toLang !== undefined) {
            queryParameters['toLang'] = requestParameters.toLang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{commId}/translate-item/{id}`.replace(`{${"commId"}}`, encodeURIComponent(String(requestParameters.commId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewCommunicationItemFromJSON(jsonValue));
    }

    /**
     */
    async communicationTranslateCommunicationItem(requestParameters: CommunicationTranslateCommunicationItemRequest, initOverrides?: RequestInit): Promise<ViewCommunicationItem> {
        const response = await this.communicationTranslateCommunicationItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communicationUpdateCommunicationRaw(requestParameters: CommunicationUpdateCommunicationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ViewCommunication>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling communicationUpdateCommunication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Communication/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutClientCommunicationToJSON(requestParameters.putClientCommunication),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewCommunicationFromJSON(jsonValue));
    }

    /**
     */
    async communicationUpdateCommunication(requestParameters: CommunicationUpdateCommunicationRequest, initOverrides?: RequestInit): Promise<ViewCommunication> {
        const response = await this.communicationUpdateCommunicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
